var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"estimate_top"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"float-right",attrs:{"alt":"Pionelectric Logo","contain":"","src":_setup.companyInfo?.logoImageUrl,"transition":"scale-transition","width":"140"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }